import { ICard } from '../../model/models/payment-methods';
import { IValidateCardResponseEntity } from '../../model/api/payment-accounts';
import { IPaymentProvider } from './payment.interface';
import { ProviderUtilities } from '../provider-utilities';
import { IOrder } from '../../model/models/order/order-interface';

export class PaymentProviderBluePay implements IPaymentProvider {
  getSignatureFields(model) {
    const fields = {
      ADDR1: model.street,
      CITY: model.city,
      MERCHDATA_Alias: '', //accountAlias,
      MERCHDATA_Bin: model.accountNumber.substr(0,6),
      NAME1: model.firstName,
      NAME2: model.lastName,
      STATE: model.stateProvince,
      ZIPCODE: model.postCode
    };

    for (const key in fields) {
      fields[key] = ProviderUtilities.removeDiacritics(fields[key], false);
    }
    return fields;
  }

  createRequest(card: ICard, response: IValidateCardResponseEntity) {
    const entity = { ...response.sourceSignature.signatureFields };

    let month = card.expiryMonth.toString();
    if (month.length === 1) {
      month = `0${month}`;
    }
    
    entity.CC_NUM = card.accountNumber;
    entity.CVCCVV2 = card.cvn;
    entity.CC_Expires = month + card.expiryYear.toString().substring(2);
    entity.TAMPER_PROOF_SEAL = response.sourceSignature.signature;
    /*
    APPROVED_URL: BLUE_PAY_RESPONSE_URL,
    DECLINED_URL: BLUE_PAY_RESPONSE_URL,
    MISSING_URL: BLUE_PAY_RESPONSE_URL,
    */

    return entity;    
  }

  handleResponse(provider, response, errorText = 'Bluepay card creation has been rejected') {
    const postobject = this.convertResponse(response);
    if (!postobject)
      provider.logPaymentError(errorText, response.url);
    return postobject;
  }

  convertResponse(response) {
    //https://secure.bluepay.com/interfaces/shpf?ORDER_ID=100783296864&MERCHDATA_BIN=&F_REBILL_MASTER=0&MERCHDATA_CUSTOMERID=2142207255&MERCHDATA_customerid=2142207255&BIN=400000&PHONE=6135550181&AVS_RESULT=_&ORIGIN=bp10emu&CUSTOMER_IP=66.82.123.234&TPS_HASH_TYPE=HMAC_SHA256&BP_STAMP=A197B26DB863EE624AE1FE01C8C6D1EB482C083D01517F7E686CD9C54A9AC16F&ISSUE_DATE=2019-10-01%2012%3A56%3A16.370301&F_CARD_PRESENT=0&CUSTOMER_CODE=100783296864&TRANSACTION_TYPE=AUTH&FRAUD_SCORE=0&EMV_APPNAME=&INVOICE_ID=100783296864&MERCHDATA_locale=en-US&AVS=_&CARD_EXPIRE=1022&BANK_NAME=&OWNER_USER_ID=100713716493&CARD_TYPE=VISA&BP_STAMP_DEF=RRNO%20ISSUE_DATE%20Result&CVV2_RESULT=_&CUST_TOKEN=&ZIPCODE=12345&F_WILL_CAPTURE=0&EMV_APPLICATION=&MERCHDATA_ISOCODEFIELD=CA&STATUS=E&PAYMENT_ACCOUNT=xxxxxxxxxxxx0119&COUNTRY=CA&EMAIL=rmt3-100_101%40mailinator.ca&Result=ERROR&ID=100783296864&MERCHDATA=alias%3D%26isocodefield%3DCA%26currency%3DCAD%26bin%3D%26locale%3Den-US%26customerid%3D2142207255&MERCHDATA_CURRENCY=CAD&STATE=QC&MODE=TEST&F_UNHELD=0&ADDR1=test&CUST_PHONE=6135550181&CITY=test&ZIP=12345&CUST_EMAIL=rmt3-100_101%40mailinator.ca&AUTH_CODE=&TPS_DEF=ADDR1%20CITY%20MERCHDATA_Alias%20MERCHDATA_Bin%20NAME1%20NAME2%20STATE%20ZIPCODE%20EMAIL%20PHONE%20CUSTOMER_IP%20MERCHANT%20TPS_HASH_TYPE%20MERCHDATA_Locale%20MERCHDATA_Currency%20TRANSACTION_TYPE%20PAYMENT_TYPE%20COUNTRY%20RESPONSEVERSION%20MODE%20MERCHDATA_CustomerID%20MERCHDATA_IsoCodeField%20AMOUNT&MERCHDATA_currency=CAD&MERCHANT=100713716492&MERCHDATA_bin=&REMOTE_IP=66.82.123.234&MERCHDATA_alias=&LOGIN_ACCOUNT_ID=100713716492&MESSAGE=DUPLICATE&TRANS_ID=100783296864&MERCHDATA_LOCALE=en-US&SOURCE_ID=100783296864&CC_EXPIRES=1022&NAME1=test&REBID=&PROCESSOR_ID=100713716655&EMV=&CVV2=_&CONNECTED_IP=62.216.223.98&AMOUNT=0.00&MERCHDATA_ALIAS=&RRNO=100783296864&TRANS_TYPE=AUTH&PAYMENT_TYPE=CREDIT&NAME2=test&CVV2_STATUS=1&MERCHDATA_isocodefield=CA&RESPONSEVERSION=9999&SHPF_FORM_ID=bluepay01&DBA=DEMO-riafinancial
    let postdata = response.url;
    const pos = postdata.indexOf('?');
    postdata = postdata.substr(pos + 1);
    const postobject = {};
    const pairs = postdata.split('&');
    for (let i=0; i < pairs.length; i++) {
      const pair = pairs[i].split('=');
      if (pair.length === 1)
        pair.push(null);
      postobject[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }

    if (postobject['Result'] !== 'APPROVED')
      return null;
    return postobject;
  }  

  handleResponsePOST(provider, response, errorText = 'Bluepay card creation has been rejected') {
    const postobject = this.convertResponsePOST(response);
    if (!postobject)
      provider.logPaymentError(errorText, response.url);
    return postobject;
  }

  convertResponsePOST(response) {
    const el = document.createElement('div');
    el.innerHTML = response.responseData;
    let postdata = '';
    const postobject = {}
    const inputs = el.getElementsByTagName('input');
    for (let i=0; i < inputs.length; i++) {
      const input = inputs[i];
      if (i > 0) {
        postdata += '&';
      }
      postdata += encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value);
      postobject[input.name] = input.value;
    }

    if (postobject['Result'] !== 'APPROVED')
      return null;
    return postobject;
  }

  async forwardResponse(provider, baseUrl, card: ICard, response): Promise<any> {
    const result = await provider.httpProvider.post(`${ baseUrl }account/card/blue-pay-response`, response);
    if (result) {
      card.accountId = result.accountId;      
      card.maskedAccountNumber = card.accountNumber.slice(-4);      
      card.accountNumber = null;
      card.cvn = null;
      // the new Payment Method Completed event requires property of payment vendor, adding that for bluepay in paymentProcessor
      if(response && response.SHPF_FORM_ID === 'bluepay01')
        card.paymentProcessor = 'Bluepay'
      return card;
    }
    return null;
  }

  async clientSideAuthorization(provider, baseUrl, order: IOrder) {
    try {

      const payload = {
        PaymentAccountId: order.cardAccount.accountId,
        SignatureFields: {
          MERCHDATA_TransactionId: order.transactionId,
          AMOUNT: order.totalAmount
        },
      };

      const result = await provider.httpProvider.put(`${ baseUrl }account/card/authorization-request`, payload);
      if (!result || !result.partnerTransactionUrl || !result.sourceSignature || 
          !result.sourceSignature.signatureFields || !result.sourceSignature.signature) {
        provider.logPaymentError('Invalid response for Bluepay authorization request', result);
        return null;
      }

      const entity = { ...result.sourceSignature.signatureFields };
      entity.CVCCVV2 = order.cardAccount.cvn;
      entity.TAMPER_PROOF_SEAL = result.sourceSignature.signature;
      // IMPORTANT otherwise we would get a HTML response which would fail in CORS
      // with DIRECT we would get CORS errors but with POST we get a response with Access-control-allow-origin and hence works well with CORS
      entity.RESPONSETYPE = 'POST';

      let postdata = '';
      Object.keys(entity).forEach((id) => {
        if (postdata.length > 0) {
          postdata += '&';
        }
        postdata += encodeURIComponent(id) + '=' + encodeURIComponent(entity[id]);
      });  

      // we had strange SSL problems with iOS when using Bluepay through the native HTTP plugin (probably an incompatibility between iOS and Bluepay SSL setup - i.e. loadbalancer affecting the SSL certificate)
      // hence we're now changing to call it always through the browser HTTP connection to solve the problems between the native iOS HTTP plugin and Bluepay
      let response: any = null;
      const start = Date.now();
      const logbody = provider.httpProvider.maskLog(postdata);
      const log = provider.logPaymentInfo('POST (fetch) ' + result.partnerTransactionUrl, logbody, this);
      try {
        await provider.httpProvider.checkConnection(log, result.partnerTransactionUrl);
    
        response = await fetch(result.partnerTransactionUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: postdata
        });
        const passed = Date.now() - start;
        const logresponse = provider.httpProvider.maskLog(response);
        provider.logPaymentInfo('Received Bluepay successfully (' + passed + ' ms)', logresponse, log);
      } catch (ex) {        
        const passed = Date.now() - start;
        provider.logPaymentError('Received Bluepay error (' + passed + ' ms)', ex, log);
      }
      if (!response || !response.body) {
        provider.logPaymentError('Empty response for Bluepay authorization request', result);
        return null;
      }
      response.responseData = await response.text();
      if (!response.responseData) {
        provider.logPaymentError('Empty response data for Bluepay authorization request', result);
        return null;
      }
      provider.logPaymentInfo('Received Bluepay response', response.responseData, log);

      const paymentResponse = this.handleResponsePOST(provider, response, 'Bluepay card authorization has been rejected');
      if (!paymentResponse)
        return null;
      
      const authResult = await provider.httpProvider.post(`${ baseUrl }account/card/blue-pay-authorization-response`, paymentResponse);
      if (authResult)
        order.cardAccount.cvn = null;
      return authResult;
    }
    catch (ex) {
      provider.logPaymentError('Exception during Bluepay authorization', ex);
      return null;
    }     
  }
}



// WEBPACK FOOTER //
// ./src/providers/payment/payment.bluepay.ts